import uqnSplit from '../functions/uqnSplit';
export default function check(uqn) {
    let type, a, b, c, d;
    let sign;
    if (uqn < 10000 || uqn >= 700000) {
        return false;
    }
    if (uqn < 100000) { // 5 digit: case 1/2
        [type, a, b, c, sign] = uqnSplit(uqn);
        if (type == 0 || type > 2) {
            return false;
        }
        if (b == 0 || c == 0 || sign > 7) {
            return false;
        }
    }
    else {
        [type, a, b, c, d, sign] = uqnSplit(uqn);
        if (type < 3 || b == 0 || d == 0) {
            return false;
        }
        if (type == 3 && sign > 3) {
            return false;
        }
        if (type == 4 && (c == 0 || sign > 7)) {
            return false;
        }
    }
    return true;
}
